import jss from 'jss'
import preset from 'jss-preset-default'

jss.setup(preset());
